import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, first, map, shareReplay } from 'rxjs/operators';
import { SSOService, newPartnerServiceContext } from '@vendasta/sso';

@Injectable({ providedIn: 'root' })
export class BusinessCenterRedirectService {
  private readonly sso = inject(SSOService);
  private readonly entryUrlCache = new Map<string, Observable<string>>();

  buildWpHostingUrl$(agid: string, partnerId: string, page = 'wp-hosting'): Observable<string> {
    return this.getEntryUrl$(partnerId).pipe(
      first(),
      map((entryUrl) => (entryUrl ? addNextUrl(entryUrl, `/account/location/${agid}/${page}`) : '')),
    );
  }

  redirectToWpHosting(agid: string, partnerId: string, page = 'wp-hosting'): void {
    this.buildWpHostingUrl$(agid, partnerId, page).subscribe((url) => {
      if (url) window.location.assign(url);
    });
  }

  private getEntryUrl$(partnerId: string): Observable<string> {
    if (!partnerId) return of('');
    const cached = this.entryUrlCache.get(partnerId);
    if (cached) return cached;
    const entry$ = this.sso.getEntryUrl('VBC', newPartnerServiceContext(partnerId)).pipe(
      catchError(() => {
        this.entryUrlCache.delete(partnerId);
        return of('');
      }),
      shareReplay({ refCount: true, bufferSize: 1 }),
    );
    this.entryUrlCache.set(partnerId, entry$);
    return entry$;
  }
}

function addNextUrl(entryUrl: string, nextUrl: string): string {
  try {
    const urlObj = new URL(entryUrl);
    const params = new URLSearchParams(urlObj.search);
    params.set('nextUrl', nextUrl);
    urlObj.search = params.toString();
    return urlObj.toString();
  } catch {
    return '';
  }
}
